/**
 * The concrete slab, and the scale it lies at.
 *
 * The floor is a tiling sprite measured in world pixels, so the tile
 * scale is what decides how big the aggregate reads in real inches. The
 * shop floor, the store's sales floor, and the dev swatch page all have
 * to agree on it, or the same concrete comes out three different sizes
 * and the one place you compare wood against it lies to you.
 */
export const CONCRETE_FLOOR_TEXTURE = "/images/concrete-floor-2-big.png";
export const CONCRETE_FLOOR_TILE_SCALE = 0.25;
